import { trackWishlistActions } from 'features/tealium';
import { initBlockEnterKeyForDisabledButton } from 'utilities/dom';

import showRequestQuoteModal from '../showRequestQuoteModal';

const HeaderToolbarItemView = Backbone.Marionette.ItemView.extend({
	template: false,
	ui: {
		btnGetQuote: '.btnGetQuote'
	},
	events: {
		'click @ui.btnGetQuote': 'getQuote'
	},
	initialize () {

		// bind UI manually since we're not using a template
		this.bindUIElements();
		initBlockEnterKeyForDisabledButton(this.ui.btnGetQuote[0]);

	},
	getQuote (e) {

		e.preventDefault();

		trackWishlistActions({
			eventAction: 'Click-RequestAQuote'
		});

		showRequestQuoteModal();

	}
});

export default HeaderToolbarItemView;
